export const types = {
  SET_DELIVERY_NUMBER: 'SET_DELIVERY_NUMBER',
  COPY_DELIVERY_PRODUCT_ITEMS: 'COPY_DELIVERY_PRODUCT_ITEMS',
  SET_USER_IS_GUEST: 'SET_USER_IS_GUEST',
  SET_SUMMARY: 'SET_SUMMARY',
  SET_GROSS_SUMMARY: 'SET_GROSS_SUMMARY',
  SET_ONLINE: 'SET_ONLINE',
  SET_TAX: 'SET_TAX',
  SET_SHIPPING_COST: 'SET_SHIPPING_COST',
  RESET: 'RESET',
  HYDRATE: 'HYDRATE',
};
